/*
 * Compact PDP support script.
 * Wraps the trailing currency code ("NZD") in the product price in a
 * <span class="dw-cur"> so it can be styled smaller/grey per the design.
 * Re-applies after variant changes (the price container re-renders).
 */
(function () {
  function wrapCurrency(container) {
    container.querySelectorAll('.price-item').forEach(function (el) {
      if (el.querySelector('.dw-cur')) return;
      Array.prototype.slice.call(el.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && /\b([A-Z]{3})\s*$/.test(node.textContent)) {
          var code = node.textContent.match(/\b([A-Z]{3})\s*$/)[1];
          node.textContent = node.textContent.replace(/\s*\b[A-Z]{3}\s*$/, ' ');
          var span = document.createElement('span');
          span.className = 'dw-cur';
          span.textContent = code;
          el.appendChild(span);
        }
      });
    });
  }

  function init() {
    var containers = document.querySelectorAll('[id^="price-template"], [id^="price-"]');
    if (!containers.length) return;
    containers.forEach(function (c) {
      wrapCurrency(c);
      new MutationObserver(function () {
        wrapCurrency(c);
      }).observe(c, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
